<template>
  <div class="kpi-pay-page" v-if="true">
    <div class="top">
      <div class="money f fvc Flex-between">
        <div>
          <div class="title">总支出金额</div>
          <div class="num">￥{{Total||0}}</div>
        </div>
        <div>
          <div class="title">
            剩余金额
            <!-- <van-icon name="question-o" class="ml5" /> -->
          </div>
          <div class="num">￥{{Remain||0}}</div>
        </div>
        <van-button size="small" @click="getBrandList">
          <span>{{brand ? brand : '按品牌筛选'}}</span>
          <van-icon name="arrow-down" />
        </van-button>
      </div>

      <div class="mt10 brandtitle">当前品牌：{{brandName}}</div>
    </div>

    <van-tabs
      v-model="typeIndex"
      title-active-color="#3283fa"
      :line-width="50"
      color="#3283fa"
      :sticky="true"
      @change="changeType"
    >
      <van-tab v-for="(type, key) in types" :key="key" :title="type.title"></van-tab>
    </van-tabs>
    <div class="TypeList" v-if="typeIndex==1">
      <div class="TotalList f">
        <div
          class="TypeItem"
          @click="changeLable('')"
          :class="brandlable==''?'active':''"
        >全部({{singleMountDetail.total}})</div>
        <div
          class="TypeItem"
          @click="changeLable('view')"
          :class="brandlable=='view'?'active':''"
        >浏览({{singleMountDetail.viewCount}})</div>
        <div
          class="TypeItem"
          @click="changeLable('fission')"
          :class="brandlable=='fission'?'active':''"
        >裂变({{singleMountDetail.fissionCount}})</div>
        <div
          class="TypeItem"
          @click="changeLable('enrollment')"
          :class="brandlable=='enrollment'?'active':''"
        >报名({{singleMountDetail.enrollmentCount}})</div>
        <div
          class="TypeItem"
          @click="changeLable('card')"
          :class="brandlable=='card'?'active':''"
        >售卡({{singleMountDetail.cardCount}})</div>
        <div
          class="TypeItem"
          @click="changeLable('thumb')"
          :class="brandlable=='thumb'?'active':''"
        >集赞({{singleMountDetail.thumbCount}})</div>
        <div
          class="TypeItem"
          @click="changeLable('seckill_user')"
          :class="brandlable=='seckill_user'?'active':''"
        >秒杀({{singleMountDetail.seckillUserCountOrder}})</div>
        <div
          class="TypeItem"
          @click="changeLable('process_self_order')"
          :class="brandlable=='process_self_order'?'active':''"
        >过程自签单({{singleMountDetail.processSelfOrderCountOrder}})</div>
        <div
          class="TypeItem"
          @click="changeLable('process_devote_order')"
          :class="brandlable=='process_devote_order'?'active':''"
        >过程贡献单({{singleMountDetail.processDevoteOrderCountOrder}})</div>
        <div
          class="TypeItem"
          @click="changeLable('live_order_cus')"
          :class="brandlable=='live_order_cus'?'active':''"
        >直播下订({{singleMountDetail.liveOrderCusCount}})</div>
        <div
          class="TypeItem"
          @click="changeLable('live_self_order')"
          :class="brandlable=='live_self_order'?'active':''"
        >直播自签品牌单({{singleMountDetail.liveSelfOrderCountOrder}})</div>
        <div
          class="TypeItem"
          @click="changeLable('live_other_order')"
          :class="brandlable=='live_other_order'?'active':''"
        >直播贡献品牌单({{singleMountDetail.liveOtherOrderCountOrder}})</div>
        <div
          class="TypeItem"
          @click="changeLable('live_self_order_change')"
          :class="brandlable=='live_self_order_change'?'active':''"
        >直播自签转单({{singleMountDetail.liveSelfOrderChangeCountOrder}})</div>
        <div
          class="TypeItem"
          @click="changeLable('live_other_order_change')"
          :class="brandlable=='live_other_order_change'?'active':''"
        >直播贡献转单({{singleMountDetail.liveOtherOrderChangeCountOrder}})</div>
        <div
            class="TypeItem"
            @click="changeLable('appointment')"
            :class="brandlable=='appointment'?'active':''"
        >直播预约({{singleMountDetail.appointmentCount}})</div>
        <div
          class="TypeItem"
          @click="changeLable('live_view')"
          :class="brandlable=='live_view'?'active':''"
        >进入直播间({{singleMountDetail.liveViewCount}})</div>
        <div
          class="TypeItem"
          @click="changeLable('go_shop')"
          :class="brandlable=='go_shop'?'active':''"
        >逛店({{singleMountDetail.goShopCount}})</div>
        <div
          class="TypeItem"
          @click="changeLable('act_sign')"
          :class="brandlable=='act_sign'?'active':''"
        >活动签到({{singleMountDetail.actSignCount}})</div>
      </div>
    </div>
    <div class="TypeList" v-if="typeIndex==2">
      <div class="TotalList f">
        <div class="TypeItem" @click="changeStep('')" :class="steplable==''?'active':''">全部</div>
        <div
          class="TypeItem"
          v-for="(item, index) in stepMountList"
          :key="index"
          @click="changeStep(item.id)"
          :class="steplable==item.id?'active':''"
        >{{item.stepName}}({{item.amount}})</div>
      </div>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="— 暂无更多数据 —"
      class="content"
    >
      <van-cell v-for="(item, index) in showList" :key="index">
        <div class="f fbt text">
          <div class="f">
            <div class="one-nowrap mr10">{{item.kpiUserName}}</div>
            <div v-if="item.type=='view'">#浏览#</div>
            <div v-if="item.type=='fission'">#裂变#</div>
            <div v-if="item.type=='enrollment'">#报名#</div>
            <div v-if="item.type=='card'">#售卡#</div>
            <div v-if="item.type=='thumb'">#集赞#</div>
            <div v-if="item.type=='seckill_user'">#秒杀#</div>
            <div v-if="item.type=='process_self_order'">#过程自签单#</div>
            <div v-if="item.type=='process_devote_orde'">#过程贡献单#</div>
            <div v-if="item.type=='live_order_cus'">#直播下订#</div>
            <div v-if="item.type=='live_self_order'">#直播自签品牌单#</div>
            <div v-if="item.type=='live_other_order'">#直播贡献品牌单#</div>
            <div v-if="item.type=='live_self_order_change'">#直播自签转单#</div>
            <div v-if="item.type=='live_other_order_change'">#直播贡献转单#</div>
            <div v-if="item.type=='live_view'">#进入直播间#</div>
            <div v-if="item.type=='go_shop'">#逛店#</div>
            <div v-if="item.type=='act_sign'">#签到#</div>
            <div v-if="item.type=='appointment'">#直播预约#</div>
          </div>
          <!-- <div v-if="Number(item.score) > 0" class="active">+{{item.score}}</div>
          <div v-if="Number(item.score) <= 0">{{item.score}}</div>-->
          <div style="color:blue">{{item.amount}}</div>
        </div>
        <div class="time">
          <div>{{item.happenTime}}</div>
        </div>
      </van-cell>
    </van-list>

    <van-popup v-model="show" position="bottom">
      <van-picker
        show-toolbar
        title="选择品牌"
        :columns="BrandList"
        @cancel="show = !show"
        @confirm="chosseBrand"
        value-key="name"
      />
    </van-popup>

    <div class="home-over-btn">
      <router-link :to="{ name: 'kpi.home', query: { user_id: user_id, kpi_uid: kpi_userid,act_id: activity_id}}">
        <img src="https://j.weizan.cn/youxiang/images/home-over.png"/>
        首页
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activity_id: this.$route.query.act_id || localStorage.getItem("act_id"),
      user_id: localStorage.getItem("user_id"),
      kpi_userid: localStorage.getItem("kpi_user_id") || null,
      typeIndex: 0,
      type: 1,
      page: 1,
      loading: false,
      finished: true,
      types: [
        { title: "全部", value: 0 },
        { title: "单项奖励金", value: 1 },
        { title: "任务奖励金", value: 2 },
      ],
      list: [],
      user: null,
      kpi_user: null,
      total_balance: 0,
      brands: [],
      brand: "",
      brand_id: "",
      columns: ["全部"],
      show: false,
      searchquery: {
        brand: "老干妈",
        type: "all", //奖励类型，全部all、单项奖励金single、任务奖励金task，
        lable: "", //view：浏览，fission：裂变，enrollment：报名，card：售卡，thumb：集赞，seckill_user：秒杀用户，process_self_order：过程自签单，process_devote_orde：过程贡献单，live_order_cus：直播签单客户，live_self_order：直播自签品牌，live_other_order：直播贡献单，live_self_order_change：直播自签转单，live_other_order_change：直播贡献转单，live_view：进入直播间，go_shop：逛店，act_sign：活动签到’
      },
      // 7.25参数
      Total: 0,
      Remain: 0,
      showList: [],
      brandId: "",
      brandtype: "",
      brandlable: "",
      BrandList: [],
      stepId: "",
      singleMountDetail: {
        total: 0,
        viewCount: 0,
        appointmentCount: 0,
        fissionCount: 0,
        cardCount: 0,
        enrollmentCount: 0,
        thumbCount: 0,
        liveViewCount: 0,
        goShopCount: 0,
        actSignCount: 0,
        seckillUserCountOrder: 0,
        liveSelfOrderCountOrder: 0,
        liveOtherOrderCountOrder: 0,
        liveSelfOrderChangeCountOrder: 0,
        liveOtherOrderChangeCountOrder: 0,
        processSelfOrderCountOrder: 0,
        processDevoteOrderCountOrder: 0,
        liveOrderCusCount: 0,
      },
      stepMountList: [],
      steplable: "",
      brandName: "全部品牌",
    };
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    // 获取活动支出详情
    // 首先是获取品牌名，然后默认是全部（隐藏二级选择，type和stepId都传空）
    // 如果是单项就显示二级选择，stepID为空
    // 如果是任务奖励金则显示二级各阶段任务名的奖励明细
    async getActFinanceExpend() {
      var brandId = this.brandId; //品牌Id（必传）
      var stepId = this.stepId; //任务奖励金阶段Id
      var type = this.brandtype; //单项奖励金搜索
      var show = "all";
      if (this.typeIndex == 0) {
        show = "all";
      } else if (this.typeIndex == 1) {
        show = "single";
      } else if (this.typeIndex == 2) {
        show = "step";
      }
      let res = await this.$http.post(`/v1/kpiuser/act_finance_expend`, {
        brandId: brandId,
        show: show,
        type: type,
        stepId: stepId,
        page: 1,
        size: 1000,
      });
      console.log(res);
      if (res.data && res.code == 0) {
        this.showList = res.data.list;
      } else {
        this.$toast(res.msg);
      }
    },
    // 获取单项奖金数据内容，在选择活动后调用（默认调用当前local的活动数据）
    async getSingleMount() {
      var actId = localStorage.getItem("act_id"); //活动Id（必传）
      var brand = this.brandId; //品牌Id（必传）
      let res = await this.$http.post(
        `/v1/kpiuser/single_mount?actId=${actId}&brandId=${brand}`
      );
      console.log(res, 121313111111);
      if (res.data) {
        this.singleMountDetail = res.data;
      }
    },
    // 获取阶段任务奖励合计内容，在选择活动后调用（默认调用当前local的活动数据）
    async getStepMount() {
      var actId = localStorage.getItem("act_id"); //活动Id（必传）
      var brand = this.brandId; //品牌Id（必传）
      let res = await this.$http.post(
        `/v1/kpiuser/step_mount?actId=${actId}&brandId=${brand}`
      );
      console.log(res);
      if (res.data) {
        this.stepMountList = res.data;
      }
    },
    // 查询活动总支出、剩余金额
    async getTotalMount() {
      let res = await this.$http.post("/v1/kpiuser/total_mount");
      console.log(res);
      if (res.data && res.code == 0) {
        this.Total = res.data.total;
        this.Remain = res.data.remain;
      }
    },
    // 获取参与的品牌列表
    async getBrandList() {
      var actId = localStorage.getItem("act_id");
      let res = await this.$http.post(`/v1/taskmanage/list`, {
        actId: actId,
        catId: "",
        name: "",
        page: 1,
        size: 1000,
      });
      console.log(res);
      if (res.data && res.code == 0) {
        this.BrandList = res.data.list;
        this.show = true;
      }
    },
    // async changeActivity() {
    //   let res = await this.$http.post("/v1/kpiuser/all_act");
    //   console.log(res);
    //   this.columns = res.data;
    //   this.show = true;
    // },
    changeLable(lable) {
      this.brandlable = lable;
      this.brandtype = lable;
      this.showList = [];
      this.getActFinanceExpend();
    },
    changeStep(lable) {
      this.steplable = lable;
      if (lable) {
        this.stepId = Number(lable);
      } else {
        this.stepId = lable;
      }
      this.showList = [];
      this.getActFinanceExpend();
    },
    changeType(val) {
      // 默认全部，隐藏二级选择，stepId和type传空
      if (val == 0) {
        this.stepId = "";
        this.brandtype = "";
      } else if (val == 1) {
        // 默认全部，显示单项奖励金二级选择
        this.stepId = "";
        this.brandtype = "";
        this.getSingleMount();
      } else if (val == 2) {
        // 默认全部，显示任务阶段奖励二级选择step_mount,不传默认显示全部？
        this.stepId = "";
        this.brandtype = "";
        this.getStepMount();
      }
      // 请求二级列表
      // 切换时转为全部
      this.brandlable = "";
      this.steplable = "";
      // 参数修改完毕，进行搜索
      this.showList = [];
      this.getActFinanceExpend();
    },
    // 确认选择品牌，根据品牌来筛选,先清除数据,重新获取二级筛选
    chosseBrand(val) {
      console.log(val);
      this.brandId = val.id;
      this.brandName = val.name;
      // 清空列表和二级筛选数据
      this.clearData();
      // 重置为全部任务类型
      this.typeIndex = 0;
      // 请求二级搜索列表
      // this.getSingleMount();
      // this.getStepMount();
      this.getActFinanceExpend();
      this.show = false;
    },
    clearData() {
      this.showList = [];
      this.singleMountDetail = {
        total: 0,
        viewCount: 0,
        fissionCount: 0,
        cardCount: 0,
        enrollmentCount: 0,
        thumbCount: 0,
        liveViewCount: 0,
        goShopCount: 0,
        actSignCount: 0,
        seckillUserCountOrder: 0,
        liveSelfOrderCountOrder: 0,
        liveOtherOrderCountOrder: 0,
        liveSelfOrderChangeCountOrder: 0,
        liveOtherOrderChangeCountOrder: 0,
        processSelfOrderCountOrder: 0,
        processDevoteOrderCountOrder: 0,
        liveOrderCusCount: 0,
      };
      this.stepMountList = [];
      this.stepId = "";
      this.brandtype = "";
      this.brandlable = "";
      this.steplable = "";
    },
  },
  created() {
    // 初始进入加载全部品牌全部数据()
    this.getActFinanceExpend();
    // 二级筛选list
    // this.getSingleMount();
    // this.getStepMount();
    // 活动支出和剩余数据
    this.getTotalMount();
  },
};
</script>

<style lang="less" scoped>
.kpi-pay-page {
  .TypeList {
    width: 100%;
    height: 48px;
    background: #f8f8f8;
    overflow: hidden;
    .TotalList {
      height: 48px;
      display: flex;
      overflow-x: auto;
      // justify-content: space-between;
      .TypeItem {
        margin-top: 12px;
        margin-left: 10px;
        padding: 5px 10px;
        background: white;
        border-radius: 10px;
        align-self: baseline;
        border: 1px solid #999999;

        text-align: center;
        color: #283b42;
        font-weight: bold;
        flex-basis: 20px;
        flex-shrink: 0;
        white-space: nowrap;
      }
      .active {
        border: 1px solid #0084ff;
        color: #0084ff;
      }
    }
  }
  .top {
    background: url("https://j.weizan.cn/youxiang/images/finance_img.jpg")
      no-repeat 0 0;
    background-size: 100% 100%;
    img {
      width: 100%;
      vertical-align: bottom;
    }
    .brandtitle {
      color: #ffffff;
      padding: 0px 20px 10px 20px;
    }
    .money {
      color: #ffffff;
      padding: 30px 20px 10px 20px;
      .title {
        color: rgba(255, 255, 255, 0.7);
        margin-bottom: 5px;
      }
      .num {
        font-size: 24px;
      }
      button {
        color: #ffffff;
        border: none;
        border-radius: 20px;
        background-color: rgba(255, 255, 255, 0.2);
        padding: 0 15px;
        .van-button__text {
          display: flex;
          justify-content: space-between;
          align-items: center;
          min-width: 100px;
        }
        .van-icon {
          font-size: 16px;
        }
      }
    }
  }

  .content {
    // margin-top: 10px;
    .flex {
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: space-between;
    }
    .active {
      color: #3283fa;
    }
    .text {
      line-height: 30px;
    }
    .time {
      color: #999999;
      font-size: 12px;
    }
    .van-cell {
      padding: 7px 15px;
    }
  }
}
</style>